import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

export const DropDownItem = ({
  label,
  onClick,
  closeMenu,
  containerClassName,
  disabled = false,
}: {
  label: string
  onClick?: () => void
  closeMenu?: () => void
  containerClassName?: string
  disabled?: boolean
}) => {
  return (
    <div
      className={clsx([containerClassName, { [s.disable]: disabled }])}
      onClick={() => {
        if (!disabled) {
          onClick && onClick()
          closeMenu && closeMenu()
        }
      }}
    >
      <span>{label}</span>
    </div>
  )
}

export default DropDownItem
